module.exports = __webpack_public_path__ + "img/cart-fill.6d495e55.svg";